// The customer's Live/Not Live in the Status Check column's own terms, so the two read the same.
// Stored as the customer sent it; anything else they send shows verbatim.
const LIVE_STATUS_LABELS: Record<string, string> = {
  live: 'Available',
  'not live': 'Removed'
};

export function customerLiveStatusLabel(liveStatus: string | null): string | null {
  return liveStatus === null ? null : (LIVE_STATUS_LABELS[liveStatus.toLowerCase()] ?? liveStatus);
}

// The customer's decision as they gave it, in sentence case for display: "Remove", "Restrict",
// "Approve", "No violation". Null when they left it blank.
export function customerDecisionLabel(decision: string | null): string | null {
  return decision ? decision.charAt(0) + decision.slice(1).toLowerCase() : null;
}

// The customer saying the submission was not a violation: Pioneer's APPROVE, Falcon's NO VIOLATION.
export function isFalsePositiveDecision(decision: string | null): boolean {
  return decision === 'APPROVE' || decision === 'NO VIOLATION';
}

// Whatever else the customer told us, in the order shown everywhere: the platform status (Pioneer),
// their notes and how many pins they queued for action (Falcon).
export function customerFeedbackDetails(feedback: {
  live_status: string | null;
  notes: string | null;
  pins_actioned: number | null;
}): Array<{label: string; value: string}> {
  const details: Array<{label: string; value: string}> = [];
  const liveStatus = customerLiveStatusLabel(feedback.live_status);
  if (liveStatus) {
    details.push({label: 'Platform status', value: liveStatus});
  }

  if (feedback.notes) {
    details.push({label: 'Notes', value: feedback.notes});
  }

  if (feedback.pins_actioned !== null) {
    details.push({label: 'Pins queued for action', value: String(feedback.pins_actioned)});
  }

  return details;
}

// The decisions each customer's file uses: Pioneer's (YouTube) and Falcon's (Pinterest). Values are
// what the customer_feedback filter takes.
export const CUSTOMER_DECISIONS = {
  youtube: [
    {value: 'remove', label: 'Remove'},
    {value: 'restrict', label: 'Restrict'},
    {value: 'approve', label: 'Approve'}
  ],
  pinterest: [
    {value: 'actioned', label: 'Actioned'},
    {value: 'no violation', label: 'No violation'},
    {value: 'other', label: 'Other'},
    {value: 'pending review', label: 'Pending review'}
  ]
};
